import * as $ from 'jquery';
var BaseComponent = (function () {
    function BaseComponent(element) {
        if (element) {
            this._element = element;
            this._$element = $(this._element);
            this._$element.data('instance', this);
        }
    }
    BaseComponent.prototype.init = function () { };
    BaseComponent.prototype.destroy = function () {
        this._$element.data('instance', null);
    };
    Object.defineProperty(BaseComponent.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (value) {
            this._element = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "$element", {
        get: function () {
            return this._$element;
        },
        set: function (value) {
            this._$element = value;
        },
        enumerable: true,
        configurable: true
    });
    return BaseComponent;
}());
export { BaseComponent };
//# sourceMappingURL=base_component.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@pixelart/component-handler/dist/base_component.class.js
// module id = 45
// module chunks = 0